var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"call-me-box"},[_c('am-icon',{attrs:{"icon":"check_circle_outline","color":"positive"}}),_c('am-typography',{attrs:{"color":"medium","variant":"body1"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }